import { MediaManagerApi } from './implementations/MediaManagerApi';
export const createMediaManagerApi = params => new MediaManagerApi(params);
export { MediaManagerApi };
//# sourceMappingURL=index.js.map